import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
import { Flame } from "lucide-react";

/** Home widget: gentle streak counter with a 7-day dot row. */
export function StreakBadge() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/streak").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  if (data.current === 0 && data.total_days === 0) {
    return (
      <section className="rounded-2xl bg-white border border-[color:var(--mano-border)] p-4 flex items-center gap-3" data-testid="home-streak">
        <div className="h-10 w-10 rounded-xl bg-[color:var(--mano-bg)] text-[color:var(--mano-ink-soft)] flex items-center justify-center">
          <Flame size={16} />
        </div>
        <div className="flex-1">
          <div className="text-sm font-semibold">Start a gentle streak today</div>
          <div className="text-xs text-[color:var(--mano-ink-soft)]">Open any therapy to begin — one small step is enough.</div>
        </div>
        <Last7Dots last7={data.last7} />
      </section>
    );
  }
  const isBig = data.current >= 3;
  const msg = data.current === 1
    ? "Your streak begins today — nice."
    : data.current < 4
    ? `You've opened a therapy ${data.current} days in a row.`
    : data.current < 7
    ? `${data.current}-day streak — quiet, steady care.`
    : `${data.current}-day streak — a real habit is forming.`;
  return (
    <section className="rounded-2xl bg-white border border-[color:var(--mano-border)] p-4 flex items-center gap-3" data-testid="home-streak">
      <div className={`h-10 w-10 rounded-xl flex items-center justify-center ${
        isBig ? "bg-amber-100 text-amber-600" : "bg-[color:var(--mano-primary)]/10 text-[color:var(--mano-primary)]"
      }`}>
        <Flame size={16} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-sm font-semibold" data-testid="streak-msg">{msg}</div>
        <div className="text-[11px] text-[color:var(--mano-ink-soft)]">
          Best streak: {data.best} day{data.best === 1 ? "" : "s"} · Total active days: {data.total_days}
        </div>
      </div>
      <Last7Dots last7={data.last7} />
    </section>
  );
}

function Last7Dots({ last7 }) {
  return (
    <div className="flex items-center gap-1" data-testid="streak-last7">
      {last7.map((d) => (
        <span
          key={d.date}
          title={d.date}
          className={`h-2.5 w-2.5 rounded-full ${
            d.active ? "bg-[color:var(--mano-primary)]" : "bg-[color:var(--mano-border)]"
          }`}
        />
      ))}
    </div>
  );
}
